import { useStaticIntl } from '../../i18n';
export const canQuitEditor = (intl) => ({ isTouched }) => {
    if (isTouched) {
        // eslint-disable-next-line no-alert
        return window.confirm(intl.$t({
            id: 'Alert.UnsavedChanges',
            defaultMessage: 'You have unsaved changes. Are you sure you want to discard them?',
        }));
    }
    return true;
};
export const useCanQuitEditor = () => {
    return useStaticIntl(canQuitEditor);
};
//# sourceMappingURL=state.js.map